import { render, staticRenderFns } from "./AdminReports.vue?vue&type=template&id=0e13d179"
import script from "./AdminReports.vue?vue&type=script&lang=js"
export * from "./AdminReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e13d179')) {
      api.createRecord('0e13d179', component.options)
    } else {
      api.reload('0e13d179', component.options)
    }
    module.hot.accept("./AdminReports.vue?vue&type=template&id=0e13d179", function () {
      api.rerender('0e13d179', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminReports.vue"
export default component.exports